import type { ButtonHTMLAttributes, ReactNode } from 'react';

import styles from './Button.module.css';

export type ButtonVariant = 'default' | 'primary' | 'ghost' | 'danger';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  block?: boolean;
  children: ReactNode;
}

/**
 * Przycisk. Świadomie bez wariantu „rozmiar" — gęstość niesie kontekst,
 * a trzy rozmiary przycisku to trzy okazje do wybrania niewłaściwego.
 *
 * ⚠ `type="button"` domyślnie, nie `submit`. Domyślny `submit` w HTML jest
 * najczęstszym źródłem przypadkowego wysłania formularza przy kliknięciu
 * w „Anuluj" albo w przycisk pomocniczy.
 */
export function Button({
  variant = 'default',
  block = false,
  type = 'button',
  className,
  children,
  ...rest
}: ButtonProps) {
  const classes = [
    styles['button'],
    variant !== 'default' ? styles[variant] : undefined,
    block ? styles['block'] : undefined,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    // eslint-disable-next-line react/button-has-type
    <button type={type} className={classes} {...rest}>
      {children}
    </button>
  );
}
